import React from "react";

/* Loading skeletons (SBX-08 §10) — shimmer blocks, no full-page spinners. */
const Block = ({ className = "", style }) => <div className={`animate-pulse rounded-lg bg-[#141417] ${className}`} style={style} />;

export function BoardSkeleton() {
  return (
    <div className="space-y-4" data-testid="board-skeleton">
      {[0, 1].map((s) => (
        <div key={s} className="overflow-hidden rounded-[18px]" style={{ background: "#111114", boxShadow: "inset 0 0 0 1px #1F1F23" }}>
          <div className="flex items-center justify-between px-4" style={{ height: 50, background: "#0F0F12", borderBottom: "1px solid #1A1A1E" }}>
            <Block className="h-4 w-32" />
            <div className="hidden gap-3 lg:flex"><Block className="h-3 w-14" /><Block className="h-3 w-14" /><Block className="h-3 w-16" /></div>
          </div>
          {[0, 1].map((r) => (
            <div key={r} className="grid items-center gap-2 px-4 py-4 lg:gap-2" style={{ gridTemplateColumns: "minmax(0,1fr) repeat(3,64px)" }}>
              <div className="flex items-center gap-2.5"><Block className="h-7 w-7 rounded-full" /><Block className="h-4 w-24" /></div>
              <Block className="h-11" /><Block className="h-11" /><Block className="h-11" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export function EventSkeleton() {
  return (
    <div className="space-y-4" data-testid="event-skeleton">
      <Block className="h-[200px] rounded-[24px]" />
      <div className="flex gap-7"><Block className="h-6 w-20" /><Block className="h-6 w-28" /><Block className="h-6 w-32" /></div>
      <Block className="h-5 w-40" />
      <Block className="h-[150px] rounded-[18px]" />
    </div>
  );
}

export function PropsSkeleton() {
  return (<div className="space-y-2" data-testid="props-skeleton">{[0, 1, 2].map((i) => <Block key={i} className="h-16 rounded-[18px]" />)}</div>);
}

export function BoardError({ onRetry }) {
  return (
    <div className="rounded-[18px] px-4 py-16 text-center" style={{ background: "#101013", boxShadow: "inset 0 0 0 1px #1F1F23" }} data-testid="board-error">
      <p className="font-display text-[17px] font-extrabold text-white">We couldn&rsquo;t load the board</p>
      <p className="mx-auto mt-1.5 max-w-[320px] text-[13px] text-[#71717a]">Your slip is saved. Prices on screen may be out of date.</p>
      <button onClick={onRetry} className="mx-auto mt-4 inline-flex h-11 items-center rounded-xl px-4 text-[13px] font-bold text-[#0A0A0A]" style={{ background: "#FAFAFA" }}>Try again</button>
    </div>
  );
}
